module.exports = __webpack_public_path__ + "static/104822112-wide.9e3bf6ea.jpg";